"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var react_tooltip_lite_1 = __importDefault(require("react-tooltip-lite"));
var TOOLTIP_CLS = 'syl-tooltip';
exports.TOOLTIP_CLS = TOOLTIP_CLS;
var POPPER_CLS = 'syl-popper';
exports.POPPER_CLS = POPPER_CLS;
var Tooltip = function (_a) {
    var _b;
    var children = _a.children, content = _a.content, getRef = _a.getRef, _c = _a.tipContentClassName, tipContentClassName = _c === void 0 ? '' : _c, rest = __rest(_a, ["children", "content", "getRef", "tipContentClassName"]);
    return (react_1.default.createElement(react_tooltip_lite_1.default, __assign({ content: content, arrowSize: 6, useDefaultStyles: false, tipContentClassName: classnames_1.default(TOOLTIP_CLS, (_b = {},
            _b[tipContentClassName] = tipContentClassName,
            _b)), padding: "8px 12px", zIndex: 1100, eventOff: 'onClick', ref: function (t) {
            getRef && getRef(t);
        } }, rest), children));
};
exports.Tooltip = Tooltip;
var Popper = function (_a) {
    var _b;
    var children = _a.children, content = _a.content, tipContentClassName = _a.tipContentClassName, isOpen = _a.isOpen, getRef = _a.getRef, rest = __rest(_a, ["children", "content", "tipContentClassName", "isOpen", "getRef"]);
    return (react_1.default.createElement(react_tooltip_lite_1.default, __assign({ content: content, arrow: false, useDefaultStyles: false, useHover: false, tipContentClassName: classnames_1.default(POPPER_CLS, (_b = {},
            _b[tipContentClassName || ''] = tipContentClassName,
            _b.visible = isOpen,
            _b)), padding: "0", direction: "down-start", zIndex: 1002, isOpen: isOpen, ref: function (t) { return getRef && getRef(t); } }, rest), children));
};
exports.Popper = Popper;
var IconButton = function (_a) {
    var children = _a.children, buttonRef = _a.buttonRef, rest = __rest(_a, ["children", "buttonRef"]);
    return (react_1.default.createElement("button", __assign({ className: "syl-toolbar-button", ref: buttonRef, type: "button" }, rest), children));
};
exports.IconButton = IconButton;
var ListItem = function (_a) {
    var _b;
    var children = _a.children, className = _a.className, listRef = _a.listRef, rest = __rest(_a, ["children", "className", "listRef"]);
    return (react_1.default.createElement("li", __assign({ className: classnames_1.default('syl-toolbar-tool-horizon', (_b = {},
            _b[className] = className,
            _b)), ref: listRef }, rest),
        react_1.default.createElement("button", { className: "syl-toolbar-tool-horizon-content", type: "button" }, children)));
};
exports.ListItem = ListItem;
var List = function (_a) {
    var _b;
    var children = _a.children, className = _a.className, getRef = _a.getRef, rest = __rest(_a, ["children", "className", "getRef"]);
    return (react_1.default.createElement("ol", __assign({ className: classnames_1.default('syl-toolbar-menu', (_b = {},
            _b[className] = className,
            _b)), ref: getRef }, rest), children));
};
exports.List = List;
var getTooltip = function (_a) {
    var editor = _a.editor, defaultTooltip = _a.defaultTooltip, configTooltip = _a.configTooltip;
    var locale = editor.configurator.getLocaleValue(name);
    var localeTip = locale.tooltip;
    var dTooltip = localeTip || defaultTooltip;
    return configTooltip || localeTip || dTooltip || name;
};
exports.getTooltip = getTooltip;
//# sourceMappingURL=utils.js.map